/*eslint no-extra-boolean-cast: "off"*/

import React from 'react';
import PropTypes from 'prop-types';
import dig from 'object-dig';
import formatNumber from '~/utils/Number/formatNumber';
import formatPhone from '~/utils/Number/formatPhone';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';

// style for this view
const styles = () => ({
  showInput: {
    borderBottom: '1px solid #efdfdf',
  },
});

class CrudInputShow extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    type: PropTypes.oneOf(['string', 'boolean', 'float', 'object', 'cpf']),
    digObject: PropTypes.arrayOf(PropTypes.string),
    floatPrecision: PropTypes.number,
    extra: PropTypes.any,
  };

  static defaultProps = {
    type: 'string',
    floatPrecision: 3,
  };

  isCPFValid = (cpf) => {
    if (!cpf) return false;
    if (typeof cpf !== 'string') return false;

    // Remove caracteres não numéricos
    cpf = cpf.replace(/[^\d]/g, "");
  
    // Verifica se o CPF tem 11 dígitos ou é uma sequência repetida
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
      return false;
    }
  
    // Calcula o primeiro dígito verificador
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let firstVerifier = (sum * 10) % 11;
    if (firstVerifier === 10) firstVerifier = 0;
  
    // Valida o primeiro dígito
    if (firstVerifier !== parseInt(cpf.charAt(9))) {
      return false;
    }
  
    // Calcula o segundo dígito verificador
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    let secondVerifier = (sum * 10) % 11;
    if (secondVerifier === 10) secondVerifier = 0;
  
    // Valida o segundo dígito
    if (secondVerifier !== parseInt(cpf.charAt(10))) {
      return false;
    }
  
    // CPF válido
    return true;
  }

  formatCPF = (cpf) => {
    return cpf.replace(
      /(\d{3})(\d{3})(\d{3})(\d{2})/,
      '$1.$2.$3-$4'
    );
  }

  formattedValue = () => {
    const { value, type, digObject, floatPrecision, extra = '' } = this.props;

    // CPF so e formatado quando o campo e EXPLICITAMENTE de CPF (type='cpf').
    // Antes havia auto-deteccao por isCPFValid(value), que aplicava a mascara de
    // CPF em telefones (CPF e celular tem ambos 11 digitos, entao um telefone
    // podia passar na validacao de CPF e sair mascarado errado).
    if (type === 'cpf') {
      return this.isCPFValid(value) ? this.formatCPF(value) : value || '';
    }

    //check if value is only numbers to format phone
    if (type === 'string' && /^\d+$/.test(value) && value.length > 10) {
      try {
        const countryCode = Number(extra.id) === 2 ? 'usa' : 'br';
        return formatPhone(value, countryCode);
      } catch (e) {
        console.error(e);
      }
    }

    switch (type) {
      case 'boolean':
        return Boolean(value) ? 'Sim' : 'Não';
      case 'float':
        return formatNumber(value, { precision: floatPrecision });
      case 'object':
        return dig(value, ...digObject) || '';
      default:
        return value ? value : '';
    }
  };

  render() {
    const {
      classes,
      type,
      value,
      floatPrecision,
      digObject,
      multiline = false,
      ...props
    } = this.props;

    return (
      <TextField
        {...props}
        fullWidth
        InputLabelProps={{
          shrink: true,
          style: { marginTop: -6 },
        }}
        value={this.formattedValue()}
        margin="normal"
        readOnly
        InputProps={{
          className: classes.showInput,
          readOnly: true,
          disableUnderline: true,
          multiline: multiline,
        }}
      />
    );
  }
}

export default withStyles(styles)(CrudInputShow);

/* EXEMPLO DE USO
  <CrudInputShow
    label="Nome"
    value={user.nome}
  />
  <CrudInputShow
    label="Boolean"
    type="boolean"
    value={true}
  />
  <CrudInputShow
    label="Boolean"
    type="boolean"
    value={false}
  />
  <CrudInputShow
    label="Float"
    type="float"
    value={1280.98722}
    floatPrecision={3}
  />
  <CrudInputShow
    label="Object"
    type="object"
    value={user.toObject()}
    digObject={['senha']}
  />
*/
